
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"26","height":"26","viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"13","cy":"13","r":"13","fill":"#E5F9EA"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.9992 19.5C12.6659 19.5 12.3958 19.2053 12.3958 18.8418V8.74723L8.82937 12.6374C8.59373 12.8945 8.21164 12.8945 7.976 12.6374C7.74029 12.3803 7.74029 11.9636 7.976 11.7065L12.5725 6.69277C12.8082 6.43574 13.1903 6.43574 13.4259 6.69277L18.0225 11.7065C18.2581 11.9636 18.2581 12.3803 18.0225 12.6374C17.7868 12.8945 17.4047 12.8945 17.1691 12.6374L13.6027 8.74723V18.8418C13.6027 19.2053 13.3325 19.5 12.9992 19.5Z","fill":"#00C334"}})])
          )
        }
      }
    